import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import AppHeaderTopRow from './shared/top/index.js';
import AppHeaderBottomBlock from './shared/bottom/index.js';
import AppHeaderMobileMenu from './shared/mobileMenu/index.js';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import { withTranslation } from 'react-i18next';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const HeaderComponent = (props) => {
  const [menuOpened, setMenuOpened] = useState(false);
  const [searchOpened, setSearchOpened] = useState(false);
  const { disableSearchIcon } = props.params;

  const headerRef = useRef();

  useEffect(() => {
    if (menuOpened) {
      disableBodyScroll(headerRef.current);
    } else {
      enableBodyScroll(headerRef.current);
    }
    return () => {
      clearAllBodyScrollLocks();
    };
  }, [menuOpened]);
  useEffect(() => {
    if (searchOpened) {
      disableBodyScroll(document.getElementById('popup-search-content-id'));
    } else {
      enableBodyScroll(document.getElementById('popup-search-content-id'));
    }
    return () => {
      clearAllBodyScrollLocks();
    };
  }, [searchOpened]);

  if (!props?.fields || !props.params)
    return <GenericPlaceholder componentName="HeaderComponent" />;
  const isEliteTheme = props?.fields?.IsEliteTheme?.value;
  return (
    <>
      <div
        className={clsx(
          'app-header-wrapper',
          isEliteTheme ? 'theme-elite' : 'theme-default',
          'add-margins',
          props?.params?.Styles
        )}
      >
        <AppHeaderTopRow
          {...props}
          disableSearchIcon={disableSearchIcon}
          menuOpened={menuOpened}
          setMenuOpened={setMenuOpened}
          searchOpened={searchOpened}
          setSearchOpened={setSearchOpened}
          isEliteTheme={isEliteTheme}
        />
        <AppHeaderBottomBlock {...props} className="app-header-bottom-pc" />
        <AppHeaderMobileMenu
          {...props}
          ref={headerRef}
          className="app-header-bottom-mobile"
          opened={menuOpened}
          isEliteTheme={isEliteTheme}
        />
      </div>
      <div className="mobile-spacer"></div>
    </>
  );
};

export default withTranslation()(HeaderComponent);
